var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12 9.207-6.646 6.646-.708-.707L12 7.793l7.354 7.353-.708.707L12 9.207Z",
    fill: "#141414"
  })));
};
export { SvgChevronUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIgOS4yMDcwN0w1LjM1MzU1IDE1Ljg1MzVMNC42NDY0NCAxNS4xNDY0TDEyIDcuNzkyODZMMTkuMzUzNSAxNS4xNDY0TDE4LjY0NjQgMTUuODUzNUwxMiA5LjIwNzA3WiIgZmlsbD0iIzE0MTQxNCIvPgo8L3N2Zz4K";